import type { ReactNode } from "react";
import "./ui.css";

export type BadgeTone = "neutral" | "warning" | "success";

/** Kompakte Status-/Meta-Pille; `tone` färbt nur, die Größe bleibt gleich. */
export function Badge({
  tone = "neutral",
  title,
  children,
}: {
  tone?: BadgeTone;
  title?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={tone === "neutral" ? "ui-badge" : `ui-badge ui-badge--${tone}`}
      title={title}
    >
      {children}
    </span>
  );
}
